import relationshipRuleCategory from '@/http/requests/relationshipRuleCategory'

export default {
  fetchPaginated({ commit }, data) {
    return new Promise((resolve, reject) => {
      relationshipRuleCategory.fetchPaginated(data.sortName, data.page, data.itemsPerPage, data.type, data.word)
        .then((response) => {
          const parsedData = response.data.data.relationshipRuleCategoriesPaginated;

          commit('SET_RELATIONSHIP_RULE_CATEGORY_PAGINATED', parsedData);
          resolve(response);
        })
        .catch((exception) => {
          reject(exception);
        });
    })
  },
  add({ commit }, data) {
    return new Promise((resolve, reject) => {
      relationshipRuleCategory.add(data).then(response => {
        commit('ADD_CATEGORY', response.data.data.createRelationshipRuleCategory)
        resolve(response)
      })
        .catch((error) => { reject(error) })
    })
  },
  delete({ commit }, id) {
    return new Promise(
      (resolve, reject) => {
        relationshipRuleCategory.delete(id).then(
          response => {
            commit('DELETE_CATEGORY', id);
            resolve(response);
          }
        ).catch( exception => reject(exception) );
      }
    );
  },
}
